<div class="group-box mt-4">
  @if (!hideHeader) {
    <div class="group-box-header">{{ 'AiAgent::LlmSettings' | abpLocalization }}</div>
  }
  <div class="group-box-content" [class.mt-3]="hideHeader">
    <div [formGroup]="formGroup" *blockUI="'llm-settings-block-ui'" class="llm-settings-container">
      <!-- First Row: LLM Configuration and Model -->
      <div class="row">
        <!-- Llm Configuration -->
        <div class="col-md-6">
          <div class="form-group">
            <label
              >{{ 'AiAgent::LlmConfiguration' | abpLocalization }}
              @if (!isOptional) {
                *
              }
            </label>
            <ng-select
              id="llmConfiguration"
              formControlName="{{ aiAgentFieldNames.llmConfiguration }}"
              [searchable]="true"
              [clearable]="isOptional"
              autocomplete="off"
              appendTo="body"
              caiCloseOnScroll
            >
              <ng-option
                *ngFor="let llmConfiguration of llmConfigurationList"
                [value]="llmConfiguration.id"
              >
                <div class="w-100 text-truncate" title="{{ llmConfiguration.name }}">
                  {{ llmConfiguration.name }}
                </div>
              </ng-option>
              <ng-template ng-label-tmp let-item="item">
                <div class="selected-option" title="{{ selectedLlmConfiguration?.name }}">
                  {{ selectedLlmConfiguration?.name }}
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>

        <!-- Model -->
        @if (!hideModelSelection) {
          <div class="col-md-6">
            <div class="form-group">
              <label
                >{{ 'AiAgent::LlmModel' | abpLocalization }}
                @if (!isOptional || formGroup.get(aiAgentFieldNames.llmConfiguration).value) {
                  *
                }
              </label>
              <ng-select
                id="llmModel"
                formControlName="{{ aiAgentFieldNames.llmModel }}"
                [searchable]="true"
                [clearable]="false"
                autocomplete="off"
                appendTo="body"
                caiCloseOnScroll
              >
                <ng-option *ngFor="let llmModel of llmModelList" [value]="llmModel">
                  <div class="w-100" title="{{ llmModel }}">{{ llmModel }}</div>
                </ng-option>
                <ng-template ng-label-tmp let-item="item">
                  <div class="text-truncate">{{ item }}</div>
                </ng-template>
              </ng-select>
            </div>
          </div>
        }
      </div>

      <!-- Second Row: Custom Llm Model and Reasoning Effort -->
      <div class="row mt-2">
        <!-- Custom Llm Model -->
        @if (
          !hideModelSelection && formGroup.get(aiAgentFieldNames.llmModel).value === customModel
        ) {
          <div class="col-md-6">
            <div class="form-group">
              <label>{{ 'AiAgent::CustomLlmModel' | abpLocalization }} *</label>
              <input
                type="text"
                class="form-control"
                id="llmCustomModel"
                formControlName="{{ aiAgentFieldNames.llmCustomModel }}"
                placeholder="{{ 'AiAgent::CustomLlmModelPlaceHolder' | abpLocalization }}"
              />
            </div>
          </div>
        }

        <!-- Reasoning Effort -->
        @if (enableReasoningEffortSelection) {
          @if (
            !(disableReasoningEffortSelectionOnCustomModels && isCustomModelSelected) &&
            (selectedModelSupportsReasoning ||
              isCustomModelSelected ||
              this.formGroup.get(aiAgentFieldNames.reasoningEffort).value)
          ) {
            <div class="col-md-6">
              <div class="form-group">
                @if (
                  isCustomModelSelected ||
                  selectedModelSupportsReasoning ||
                  this.formGroup.get(aiAgentFieldNames.reasoningEffort).value
                ) {
                  <label class="d-flex align-items-center">
                    <span class="me-2">{{ 'AiAgent::ReasoningEffort' | abpLocalization }}</span>
                  </label>
                }

                <div class="w-100 d-flex flex-row gap-1">
                  @if (isCustomModelSelected) {
                    <div
                      class="w-50 d-flex align-items-center py-1 px-2 justify-content-between reasoning-effort-toggle"
                    >
                      <span class="me-2">{{ '::Enable' | abpLocalization }}</span>
                      <nz-switch
                        nzSize="small"
                        [(ngModel)]="enableReasoningEffort"
                        [ngModelOptions]="{ standalone: true }"
                        (ngModelChange)="enableReasoningEffortChange($event)"
                      ></nz-switch>
                    </div>
                  }
                  @if (
                    (isCustomModelSelected && enableReasoningEffort) ||
                    selectedModelSupportsReasoning ||
                    this.formGroup.get(aiAgentFieldNames.reasoningEffort).value
                  ) {
                    <div
                      class="w-50"
                      [ngClass]="{ 'w-50': isCustomModelSelected, 'w-100': !isCustomModelSelected }"
                    >
                      <ng-select
                        id="reasoningEffort"
                        formControlName="{{ aiAgentFieldNames.reasoningEffort }}"
                        [searchable]="true"
                        [clearable]="false"
                        autocomplete="off"
                        appendTo="body"
                        caiCloseOnScroll
                      >
                        <ng-option
                          *ngFor="let reasoningEffortLevel of reasoningEffortLevels"
                          [value]="reasoningEffortLevel"
                        >
                          <div class="w-100">
                            {{
                              'AiAgent::ReasoningEffort:' + reasoningEffortLevel | abpLocalization
                            }}
                          </div>
                        </ng-option>
                      </ng-select>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        }
        <!-- end -->

        <!-- Token Per Minute -->
        @if (enableTokenPerMinuteSelection) {
          <div class="col-md-6">
            <div class="form-group">
              <label for="tokenPerMinute"
                >{{ 'AiAgent::TokenPerMinute' | abpLocalization }}
                @if (!isOptional || formGroup.get(aiAgentFieldNames.llmConfiguration).value) {
                  *
                }
              </label>
              <input
                type="number"
                id="tokenPerMinute"
                formControlName="tokenPerMinute"
                class="form-control"
                autocomplete="nope"
              />
              <small class="text-muted switch-info-text-size">
                <span [innerHTML]="'AiAgent::TokenPerMinute:Description' | abpLocalization"></span>
              </small>
            </div>
          </div>
        }
        <!-- end Token Per Minute -->
      </div>
    </div>
  </div>
</div>
